import { LEVEL_EXP_TABLE } from '../goldExpSystem.js';

/**
 * EntityStats — Encapsula el modelo de estadísticas, experiencia y regeneración de entidad.
 * Patrón Value Object / Domain Helper.
 */
export class EntityStats {
  constructor({ hp = 570, maxHp = 570, ad = 59, ap = 0, ms = 325, as = 0.658, attackRange = 600, armor = 0, mr = 0, critChance = 0, mp, maxMp, mpRegen, type = 'champion', exp, xp, gold, bounty }) {
    this.hp = hp;
    this.maxHp = maxHp;
    this.ad = ad;
    this.ap = ap;
    this.ms = ms;
    this.as = as;
    this.attackRange = attackRange;
    this.armor = armor;
    this.mr = mr;
    this.critChance = critChance;

    this.maxMp = maxMp !== undefined ? maxMp : (type === 'champion' ? 280 : 0);
    this.mp = mp !== undefined ? mp : this.maxMp;
    this.mpRegen = mpRegen !== undefined ? mpRegen : (type === 'champion' ? 1.5 : 0);

    this.gold = gold !== undefined ? gold : (type === 'champion' ? 500 : 0);
    this.exp = exp !== undefined ? exp : (xp !== undefined ? xp : 0);
    this.level = 1;
    this.bounty = bounty !== undefined ? bounty : (type === 'champion' ? 300 : 21);
    this.cs = 0;
  }

  addExperience(amount, entityType, isDead) {
    if (entityType !== 'champion' || isDead) {
      return false;
    }
    this.exp += amount;
    let leveledUp = false;
    while (this.level < LEVEL_EXP_TABLE.length && this.exp >= LEVEL_EXP_TABLE[this.level]) {
      this.level++;
      this.maxHp += 85;
      this.hp += 85;
      this.ad += 3.5;
      leveledUp = true;
    }
    return leveledUp;
  }

  getEffectiveStats(buffs = []) {
    const mods = accumulateBuffModifiers(buffs);
    return {
      ad: this.ad * (1 + mods.adPercent) + mods.ad,
      ap: this.ap * (1 + mods.apPercent) + mods.ap,
      hp: this.hp,
      maxHp: this.maxHp,
      mp: this.mp,
      maxMp: this.maxMp,
      ms: this.ms * (1 + mods.msPercent) + mods.ms,
      as: this.as,
      armor: this.armor,
      mr: this.mr
    };
  }

  consumeMana(amount, isDead) {
    if (isDead) return false;
    if (amount <= 0) return true;
    if (this.mp >= amount) {
      this.mp -= amount;
      return true;
    }
    return false;
  }
}

function accumulateBuffModifiers(buffs = []) {
  const mods = { ad: 0, ap: 0, ms: 0, adPercent: 0, apPercent: 0, msPercent: 0 };
  if (!Array.isArray(buffs)) return mods;
  buffs.forEach(buff => {
    if (buff.ad) mods.ad += buff.ad;
    if (buff.ap) mods.ap += buff.ap;
    if (buff.ms) mods.ms += buff.ms;
    if (buff.adPercent) mods.adPercent += buff.adPercent;
    if (buff.apPercent) mods.apPercent += buff.apPercent;
    if (buff.msPercent) mods.msPercent += buff.msPercent;
  });
  return mods;
}
